/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationResponse } from './NotificationResponse';
import {
    NotificationResponseFromJSON,
    NotificationResponseFromJSONTyped,
    NotificationResponseToJSON,
    NotificationResponseToJSONTyped,
} from './NotificationResponse';

/**
 * 
 * @export
 * @interface OperationResponse
 */
export interface OperationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OperationResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {string}
     * @memberof OperationResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationResponse
     */
    id?: string;
    /**
     * 
     * @type {NotificationResponse}
     * @memberof OperationResponse
     */
    notification?: NotificationResponse;
}

/**
 * Check if a given object implements the OperationResponse interface.
 */
export function instanceOfOperationResponse(value: object): value is OperationResponse {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    return true;
}

export function OperationResponseFromJSON(json: any): OperationResponse {
    return OperationResponseFromJSONTyped(json, false);
}

export function OperationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'id': json['id'] == null ? undefined : json['id'],
        'notification': json['notification'] == null ? undefined : NotificationResponseFromJSON(json['notification']),
    };
}

export function OperationResponseToJSON(json: any): OperationResponse {
    return OperationResponseToJSONTyped(json, false);
}

export function OperationResponseToJSONTyped(value?: OperationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'errorMessage': value['errorMessage'],
        'id': value['id'],
        'notification': NotificationResponseToJSON(value['notification']),
    };
}

